import { Injectable, OnInit } from '@angular/core';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs/Observable';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ToastrService } from '../../components/toastr/toastr.service';
import { AppService } from '../../services/app.service';
import { UtilityFunctions } from '../../utilities/utility-func';
import { Config } from '../../config/config';
import { StorageService } from '../../services/storage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements OnInit, CanActivate {
  public snapShot: any;
  constructor(
    private _auth: AuthService,
    private _router: Router,
    private _toaster: ToastrService,
    private appservice: AppService,
    private _utility: UtilityFunctions,
    private session: StorageService,
  ) {
  }
  ngOnInit() {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const user_id = this.session.api.local.get(Config.CONSTANTS.STORAGE.USER_ID);
    const user_role = this.session.api.local.get(Config.CONSTANTS.STORAGE.USER_ROLE);
    if (user_id) {
      if ((state.url.indexOf('threshold-configuration') > -1) ||
          (state.url.indexOf('plant-configuration') > -1) || (state.url.indexOf('email-configuration') > -1) ||
          (state.url.indexOf('ms-access-configuration') > -1) || (state.url.indexOf('device-monitoring') > -1)
          || (state.url.indexOf('notification-settings') > -1)) {
        return (user_role === 'Admin');
      }
      return true;
    }
    this._auth.deleteUserDetails();
    this._router.navigate(['p/login']);
    this._toaster.toast('error', 'Error', 'Session expired. Please login again.', true);
    return false;
  }
}
